// extracted by mini-css-extract-plugin
export default {"container":"aSpZLP","button":"I2DnI1"};